import { useEmpathyAdapter } from '@/adapters/adapter.configurator';
import { ADAPTER_CONFIG } from '@/config/adapter.config';
import { MOBILE_BANNER_CONFIG } from '@/config/banner.config';
import { MOBILE_CLOSE_CONFIG } from '@/config/close.config';
import { customConfiguratorOptions } from '@/config/configurator/custom-configurator';
import { DESKTOP_CORE_CONFIG, MOBILE_CORE_CONFIG } from '@/config/core.config';
import { DEVICE_CONFIG } from '@/config/device.config';
import { DYNAMIC_CONFIG } from '@/config/dynamic.config';
import { DESKTOP_EMPATHIZE_CONFIG, MOBILE_EMPATHIZE_CONFIG } from '@/config/empathize.config';
import { DESKTOP_FACETS_CONFIG, MOBILE_FACETS_CONFIG } from '@/config/facets.config';
import { MOBILE_HISTORY_CONFIG } from '@/config/history.config';
import { MOBILE_IDENTIFIER_SUGGESTIONS_CONFIG } from '@/config/identifier-suggestions.config';
import { DESKTOP_NEXT_QUERIES_CONFIG, MOBILE_NEXT_QUERIES_CONFIG } from '@/config/next-queries.config';
import { MOBILE_OPEN_CONFIG } from '@/config/open.config';
import { MOBILE_PARTIALS_CONFIG } from '@/config/partial.config';
import { DEFAULT_PHANTOM_COMPONENTS_CONFIG } from '@/config/phantom.config';
import { MOBILE_POPULAR_SEARCHES_CONFIG } from '@/config/popular-searches.config';
import { DESKTOP_RECOMMENDATIONS_CONFIG, MOBILE_RECOMMENDATIONS_CONFIG } from '@/config/recommendations.config';
import { MOBILE_RELATED_TAGS_CONFIG } from '@/config/related-tags.config';
import { DESKTOP_RESULTS_GRID_CONFIG, MOBILE_RESULTS_GRID_CONFIG } from '@/config/results-grid.config';
import { MOBILE_RESULTS_CONFIG } from '@/config/results.config';
import { MOBILE_SCROLL_CONFIG } from '@/config/scroll.config';
import { DESKTOP_SEARCH_BOX_CONFIG, MOBILE_SEARCH_BOX_CONFIG } from '@/config/search-box.config';
import { DESKTOP_SORT_CONFIG, MOBILE_SORT_CONFIG } from '@/config/sort.config';
import { STORE_CONFIG } from '@/config/store.config';
import { MOBILE_SUGGESTIONS_CONFIG } from '@/config/suggestions.config';
import { MOBILE_TRACK_ADD2CART_CONFIG } from '@/config/track-add2cart.config';
import { wiringConfiguration } from '@/config/wires/wiring-configuration';
import { DESKTOP_LOCALE_CONFIG } from '@/i18n/desktop/locale.config';
import { MOBILE_LOCALE_CONFIG } from '@/i18n/mobile/locale.config';
import { COMPONENTS, Components, ConfigBuilder, installEmpathyX } from '@empathybroker/ebx-gluon';
import App from './App.vue';
import BackgroundClose from './components/tuandco-background-close.vue';

installEmpathyX((appBuilder) => {
  appBuilder
    .setAdapterFactory(useEmpathyAdapter(ADAPTER_CONFIG))
    .overrideStore(STORE_CONFIG)
    .setDynamicConfig(DYNAMIC_CONFIG)
    .addPortal(BackgroundClose, '#ebx-external-background-close')
    .addPortal(Components.Smart.Close, '.ebx-header-close')
    .setAppComponent(App)
    .setCustomConfigurator(customConfiguratorOptions)
    .setPhantomComponentsConfig(DEFAULT_PHANTOM_COMPONENTS_CONFIG)
    .setConfigFor('mobile', (configBuilder: ConfigBuilder) => {
      configBuilder
        .setLocaleConfig(MOBILE_LOCALE_CONFIG)
        .setFacetsConfig(MOBILE_FACETS_CONFIG)
        .setCoreConfig(MOBILE_CORE_CONFIG)
        .setCloseConfig(MOBILE_CLOSE_CONFIG)
        .setEmpathizeConfig(MOBILE_EMPATHIZE_CONFIG)
        .setIdentifierSuggestionsConfig(MOBILE_IDENTIFIER_SUGGESTIONS_CONFIG)
        .setScrollConfig(MOBILE_SCROLL_CONFIG)
        .setRecommendationsConfig(MOBILE_RECOMMENDATIONS_CONFIG)
        .setHistoryConfig(MOBILE_HISTORY_CONFIG)
        .setResultsConfig(MOBILE_RESULTS_CONFIG)
        .setResultsGridConfig(MOBILE_RESULTS_GRID_CONFIG)
        .setPartialsConfig(MOBILE_PARTIALS_CONFIG)
        .setPopularSearchesConfig(MOBILE_POPULAR_SEARCHES_CONFIG)
        .setBannersConfig(MOBILE_BANNER_CONFIG)
        .setRelatedTagsConfig(MOBILE_RELATED_TAGS_CONFIG)
        .setSearchBoxConfig(MOBILE_SEARCH_BOX_CONFIG)
        .setSortConfig(MOBILE_SORT_CONFIG)
        .setSuggestionsConfig(MOBILE_SUGGESTIONS_CONFIG)
        .setNextQueriesConfig(MOBILE_NEXT_QUERIES_CONFIG)
        .setTrackAddToCartConfig(MOBILE_TRACK_ADD2CART_CONFIG)
        .setOpenConfig(MOBILE_OPEN_CONFIG);
    })
    .setConfigFor('desktop', (configBuilder: ConfigBuilder) => {
      configBuilder
        .setCoreConfig(DESKTOP_CORE_CONFIG)
        .setLocaleConfig(DESKTOP_LOCALE_CONFIG)
        .setFacetsConfig(DESKTOP_FACETS_CONFIG)
        .setEmpathizeConfig(DESKTOP_EMPATHIZE_CONFIG)
        .setRecommendationsConfig(DESKTOP_RECOMMENDATIONS_CONFIG)
        .setNextQueriesConfig(DESKTOP_NEXT_QUERIES_CONFIG)
        .setResultsGridConfig(DESKTOP_RESULTS_GRID_CONFIG)
        .setSearchBoxConfig(DESKTOP_SEARCH_BOX_CONFIG)
        .setSortConfig(DESKTOP_SORT_CONFIG);
    })
    .setDevicesDetectionConfig(DEVICE_CONFIG)
    .addSubConfig(wiringConfiguration);
});
